export default __webpack_public_path__ + "static/media/home_sec4.cc95ac79.png";